/* src/app/order/components/billing-information/billing-info-edit/billing-info-edit.style.scss */
.billing-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
}
.billing-header .toggle-view-section {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  text-align: center;
  color: #007d40;
  cursor: pointer;
  right: 24px;
  text-decoration: none;
}
.billing-header .toggle-view-section nb-icon {
  position: relative;
  top: 2px;
}
.billing-header h6.billing-label {
  font-family: Arial, sans-serif;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.45;
  letter-spacing: normal;
  color: #007d40;
  margin-bottom: 0;
  margin-top: 0;
}
.with-margin {
  margin: 0 0 40px 0;
}
.billing-container .hide-section {
  display: none;
}
.billing-container .toggle-row {
  padding: 40px 0 0 0;
}
.billing-container .decision-buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
.billing-container .decision-buttons #cancel-button,
.billing-container .decision-buttons #cancel-changes-button {
  margin-left: 30px;
  margin-right: 20px;
}
.with-border {
  border: 1px solid #cccccc;
  padding: 0 20px 20px 20px;
  margin: 0 0 20px 0;
}
/*# sourceMappingURL=billing-info-edit.style.css.map */
